<template>
  <section class="piece" :class="[ view ? `piece--${view}` : '', $slots.gradient ? 'has-gradient' : '' ]">
    <div class="piece__container">
      <header class="piece__header">
        <h1 class="piece__title"><slot name="header"></slot></h1>
      </header>

      <slot></slot>
    </div>

    <div v-if="$slots.gradient" class="piece__gradient">
      <slot name="gradient"></slot>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    view: String
  }
}
</script>

<style lang="scss" scoped>
.piece {
  padding-bottom: 30px;
  padding-top: 30px;

  @include media-breakpoint-up(md) {
    padding-bottom: 50px;
    padding-top: 50px;
  }

  &:first-child {
    @include media-breakpoint-up(md) {
      padding-top: 70px;
    }
  }

  &.has-gradient {
    overflow: hidden;
    padding-bottom: 80px;
    padding-top: 20px;
    position: relative;

    @include media-breakpoint-up(md) {
      padding-bottom: 130px;
      padding-top: 30px;
    }

    &:after {
      background: linear-gradient(to bottom, $white, rgba(255, 255, 255, 0.6) 57%, $theme-gray-200);
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
    }
  }

  & + &:not(.has-gradient) {
    margin-top: 20px;

    @include media-breakpoint-up(md) {
      margin-top: 30px;
    }
  }

  .has-gradient + & {
    padding-top: 0;
    margin-top: 0!important;
  }

  &--light {
    background: $white;
  }

  &__container {
    @include make-container;
    max-width: $container-width-base;

    .has-gradient & {
      position: relative;
      z-index: 10;
    }
  }

  &__header {
    margin-bottom: 30px;

    @include media-breakpoint-up(md) {
      margin-bottom: 50px;
    }
  }

  &__title {
    margin-bottom: 0;
  }

  &__gradient {
    position: absolute;
    left: 0;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    z-index: -1;
  }

  &__bg {
    height: auto;
    width: 100%;
  }
}
</style>
